import gql from "graphql-tag";

const REMOVE_OFFER = gql`
  mutation removeOffer($offerId: ID!) {
    removeOffer(offerId: $offerId)
  }
`;

export default REMOVE_OFFER;
